import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ApiVisa } from 'blg-akaun-ts-lib';
import { SessionActions } from '../../modules/session/session-controller/actions';
import { SessionSelectors } from '../../modules/session/session-controller/selectors';
import { SessionStates } from '../../modules/session/session-controller/states';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DropDownService } from '../../services/drop-down-service';
import { SharedUtilitiesHelperFunctions } from '../helper-functions';

@Component({
  selector: 'app-select-customer-dropdown',
  templateUrl: './select-customer-dropdown.component.html',
  styleUrls: ['./select-customer-dropdown.component.css']
})
export class SelectCustomerDropdownComponent implements OnInit, OnDestroy {

  @Input() customer: FormControl;
  @Input() apiVisa: ApiVisa;
  @Input() selectedGuid: string;
  @Input() label = 'Customer';
  @Output() customerSelected = new EventEmitter<any>();

  serverSideFiltering = new FormControl();
  filteredOptions$: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  selectedRow: any;
  rowData: any = [];
  key = "customer";

  protected _onDestroy = new Subject<void>();

  constructor(private dropDownService: DropDownService, 
    private readonly store: Store<SessionStates>
  ) { 
    
  }

  ngOnInit() {

    this.store.select(SessionSelectors.selectDropDownRowData).subscribe(resolved => {
      this.rowData = resolved?resolved[this.key]?resolved[this.key]:[]:[];
      console.log("rowData.length", this.rowData.length);
      if (this.rowData.length === 0) {
        this.getRowData();
      }
      else {
        this.filteredOptions$.next(this.rowData.slice());
      }
    })

    // listen for search field value changes
    this.serverSideFiltering.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filtering();
      });
  }

  ngOnChanges() {
    // console.log('ngOnChanges');
  }

  getRowData(keyword?) {
    let formData = {
      "limit" : '',
      "orderBy" : "name",
      "order" : "ASC",
    }
    this.dropDownService.get('customer', formData, this.apiVisa).subscribe(resolved => {
      this.rowData = [...this.rowData, ...resolved.data];
      this.rowData = SharedUtilitiesHelperFunctions.removeDuplicate(this.rowData, 'guid');
      
      this.rowData = this.rowData.filter(entity => entity.name !== "");

      this.store.dispatch(SessionActions.selectDropDownRowData({key: this.key, rowData: this.rowData}));
      
      //fill the drop down
      if (keyword) {
        this.filteredOptions$.next(resolved.data.slice());
      }
      else {
        this.filteredOptions$.next(this.rowData.slice());
      }
    });
  }

  filtering() {
    if (!this.rowData) {
      return;
    }

    // get the search keyword
    let search = this.serverSideFiltering.value;
    if (!search || search.length < 3) {
      this.filteredOptions$.next(this.rowData.slice());
      return;
    } else {
      search = search.toLowerCase();
      this.getRowData(search);
    }
  }

  onSelect(guid: string) {
    if (guid) {
      this.customer.patchValue(guid);
      this.selectedRow = this.rowData.find(row => row.guid === guid);
      this.customerSelected.emit(this.selectedRow);
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

}
